import { useEffect, useState } from "react";

interface HomeLoadingProps {
  assets: string[];
}

export function HomeLoading({ assets }: HomeLoadingProps) {
  const [visible, setVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);
  const [progress, setProgress] = useState(0);
  const totalAssets = assets.length || 1;

  useEffect(() => {
    let loaded = 0;
    let done = false;

    const finish = () => {
      if (done) return;
      done = true;
      setTimeout(() => {
        setFadeOut(true);
        setTimeout(() => setVisible(false), 700);
      }, 300);
    };

    const onLoad = () => {
      loaded++;
      setProgress(Math.round((loaded / totalAssets) * 100));
      if (loaded === totalAssets) finish();
    };

    if (assets.length === 0) {
      finish();
      return;
    }

    assets.forEach((src) => {
      let fired = false;
      const fire = () => {
        if (fired) return;
        fired = true;
        onLoad();
      };
      const img = new Image();
      img.onload = fire;
      img.onerror = fire;
      img.src = src;
      // 캐시된 이미지는 src 할당 직후 이미 complete 일 수 있어 onload 가 안 뜬다.
      if (img.complete) fire();
    });

    const timeout = setTimeout(() => {
      setProgress(100);
      finish();
    }, 10000);

    return () => clearTimeout(timeout);
  }, [assets, totalAssets]);

  if (!visible) return null;

  return (
    <div
      className={`loading fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-700 bg-[#0a0a0a] ${
        fadeOut ? "pointer-events-none opacity-0" : ""
      }`}
    >
      <div className="loading__inner flex flex-col items-center">
        <img
          src="/images/laftel_only.webp"
          alt="Laftel Only"
          className="loading__logo h-14 max-md:h-10 w-auto animate-[loadingLogoIn_0.8s_ease_0.2s_forwards] opacity-0 brightness-0 invert"
        />
        <div className="loading__progress mt-16 max-md:mt-10 flex flex-col items-center gap-3">
          <div className="loading__bar-wrap h-px w-[200px] overflow-hidden rounded-[1px] bg-white/15">
            <div
              className="loading__bar h-full rounded-[1px] transition-[width] duration-300 ease-out bg-white"
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="loading__num font-mono text-[11px] tracking-[0.2em] text-white/80">
            {String(progress).padStart(3, "0")}
          </p>
        </div>
      </div>
    </div>
  );
}
